<template>
  <div v-if="$auth.loading" class="spinner-container">
    <b-spinner label="Loading" class="large-spinner"></b-spinner>
  </div>

  <div v-else id="app">
    <div v-show="shouldShowNavMenu" id="nav">
      <div class="hamburger-menu" @click="toggleMenu">
        <div class="burger-button">☰</div>
      </div>

      <div class="nav-center">
        <router-link to="/">
          <img
            class="logo"
            alt="Teleport Small Corner Logo"
            src="https://teleportal-files.s3-ap-southeast-2.amazonaws.com/logocorner.png"
            link
          />
        </router-link>
      </div>

      <div class="nav-right" v-if="!$auth.loading">
        <h4 class="user">
          {{ $auth.credits }} CR
        </h4>
        <b-button
          class="buttonmenu"
          href="#"
          @click="$auth.isAuthenticated ? logout() : login()"
          size="sm"
          pill
          variant="primary"
        >
          {{ $auth.isAuthenticated ? 'LOG OUT' : 'LOG IN' }}
        </b-button>
      </div>

    </div>

    <div v-show="shouldShowNavMenu && isMenuOpen" class="menu-content">
      <router-link to="/robots">Robots</router-link>
      <router-link to="/tutorial">Tutorial</router-link>
      <router-link to="/pricing">Pricing</router-link>
      <router-link to="/about">About</router-link>
      <router-link to="/news">News</router-link>
      <router-link to="/gallery">Gallery</router-link>
      <router-link v-if="isAdmin" to="/admin">Admin</router-link>
    </div>

    <b-alert
      v-if="$auth.isAuthenticated && !$auth.user.email_verified"
      show
      :variant="emailAlertVariant"
    >
      <div v-if="emailSent === 'success'">
        <h4>
          Verification Email Sent
        </h4>

        <h4>
          Please check your email and click on the verification link.
        </h4>
      </div>

      <div v-else-if="emailSent === 'failed'">
        <h4>
          Verification Email failed to send
        </h4>

        <h4>
          Please try again later or contact support.
        </h4>
      </div>

      <div v-else>
        <h4>
          Your e-mail address has not been verified.
        </h4>

        <h4>
          Please check your email and click on the verification link.
        </h4>

        <h5>
          <strong>
            Please refresh this page once you have verified your email address.
          </strong>
        </h5>

      </div>
    </b-alert>
    <router-view />
  </div>
</template>

<script>
import Jobs from "@/services/api/controllers/jobs";
import Users from "@/services/api/controllers/users";
import VerificationEmails from "@/services/api/controllers/verification-emails";

export default {
  data: function() {
    return {
      emailAlertVariant: "info",

      emailSent: false,

      isAdmin: false,

      shouldShowNavMenu: true,

      isMenuOpen: false
    };
  },

  name: "Nav",

  watch: {
    // Existing watcher
    '$route.name'() {
      this.checkNavMenu();
    },
    // New watcher for route changes
    $route(to, from) {
      if (to.path !== from.path) {
        this.isMenuOpen = false; // Close the menu whenever the route changes
      }
    }
  },

  methods: {
    checkNavMenu() {
      const hiddenPages = ['control-robot', 'ControlRobot']; // Add your page names here, second one might be wrong...
      this.shouldShowNavMenu = !hiddenPages.includes(this.$route.name);
    },

    // Log the user in
    async login() {
      try {
        this.$auth.loginWithRedirect();

        // Register a login event
        this.$gtag.event("login-click", {
          event_category: "logins",
          event_label: "login-click"
        });
      } catch (error) {
        throw error;
      }
    },

    // Log the user out
    async logout() {
      // The user needs to be authenticated AND THEY NEED TO OWN THE SESSION
      if (this.$route.name === "control-robot" && this.$auth.isAuthenticated) {
        // Case 1: User is in the middle of a session and they are trying to log out
        this.$router.push({ path: `/sessions/${this.$route.params.id}` });
      } else {
        // Case 2: They are at any other route
        this.$auth.logout({
          returnTo: window.location.origin
        });
      }
    },

    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      console.log("Menu toggled. isMenuOpen:", this.isMenuOpen);
    },

    async resendVerificationEmail() {
      try {
        const accessToken = await this.$auth.getTokenSilently();

        const body = {
          user_id: this.$auth.user.sub,
          client_id: process.env.VUE_APP_AUTH_CLIENT_ID
        };

        await VerificationEmails.create(body, accessToken);

        this.emailAlertVariant = "success";
        this.emailSent = "success";
      } catch (error) {
        console.log("Error: Failed to resend verification email");
        console.log(error);

        this.emailAlertVariant = "danger";
        this.emailSent = "failed";
      }
    }
  },

  mounted() {
    this.checkNavMenu();
  },


  updated: async function() {
    try {
      if (!this.$auth.loading && this.$auth.isAuthenticated) {
        // If the user already exists, leave it alone, otherwise create it.
        const accessToken = await this.$auth.getTokenSilently();
        const user = await Users.show(this.$auth.user.email, accessToken);
        this.credits = user.credits;

        const roles = this.$auth.user["https://minervea.com/api/role"];

        this.isAdmin = Boolean(roles.includes("admin"));

        if (!Boolean(user)) {
          // If the user doesn't exist, we need to create the user
          await Users.create(accessToken, this.$auth.user.email);

          return;
        }
      }
    } catch (error) {
      console.log("Failed to create missing user");
      console.log(error);
    }
  }
};

</script>

<style>

.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Full viewport height */
  width: 100vw; /* Full viewport width */
}

.large-spinner {
  width: 4rem; /* Adjust size as needed */
  height: 4rem; /* Adjust size as needed */
}

#app {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;
}

.hamburger-menu {
  flex: 1;
  cursor: pointer;

  display: flex; /* Added for vertical centering */
  align-items: center; /* Align vertically */
  justify-content: flex-start;
}

.burger-button {
  font-size: 2.5rem; /* Adjust size as needed */
  cursor: pointer; /* Indicates clickable item */
  align-self: center;
}


.nav-center {
  flex: 1;

  display: flex;
  justify-content: center;
}

.nav-right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.user {
  font-size: 1.5rem;
  font-weight: 600;
  align-self: center;
  padding: 0.6vw 1vw;
  margin-top: 0.7vh; /* Slightly push down the text */
}

.buttonmenu {
  font-size: 1.3rem; /* Font size */
  color: white; /* Text color */
  font-weight: bold; /* Font weight */
  padding: 0vw 1vw; /* Padding */
  align-self: center; /* Vertical alignment */
}

.menu-content {
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #fff; /* White background for visibility */
  width: 100%; /* Full width */
  font-size: 1.5rem;
  font-weight: 600;
}

.menu-content router-link {
  text-decoration: none;
  margin: 0 10px;
  display: block;
}

.auth {
  display: flex;
  flex-direction: row;
  align-items: flex-end; /* Align items to the start (left side) */
  gap: 0.5rem; /* Space between items, alternatively use margin-bottom */
}

#nav {
  display: flex;
  justify-content: centre;
  align-items: center;
  width: 100%; /* Subtract margin from total width */
  padding: 0 3vw;
  color: #026e9f;
}



.logo {
  max-width: 23vw; /* Adjust as needed */
  height: auto; /* Maintain aspect ratio */
}

@media (max-width: 768px) {
  .logo {
    max-width: 23vw; /* Smaller size for small screens */
    height: auto; /* Maintain aspect ratio */
  }
  .user {
    font-size: 1.3rem; /* Smaller font size for user info */
    margin-top: 1.6vh;
  }

  .buttonmenu {
    font-size: 1.0rem; /* Smaller font size for buttons */
    padding: 0vw 1vw; /* Adjust padding for smaller buttons */
  }

  .menu-content {
    flex-wrap: wrap; /* Allow menu items to wrap on small screens */
    font-size: 1rem; /* Adjust font size for menu content */
  }

  .burger-button {
  font-size: 1.7rem; /* Adjust size as needed */
  cursor: pointer; /* Indicates clickable item */
  align-self: center;
}
}

@media (max-width: 500px) {

  .user {
    font-size: 0.8rem; /* Smaller font size for user info */
    margin-top: 1.5vh;
  }

  .buttonmenu {
    font-size: 0.7rem; /* Smaller font size for buttons */
    padding: 0vw 1vw; /* Adjust padding for smaller buttons */
  }

  .menu-content {
    flex-wrap: wrap; /* Allow menu items to wrap on small screens */
    font-size: 1rem; /* Adjust font size for menu content */
  }

    #app .nav #nav .nav-center {
    display: none; /* Increase specificity to ensure it overrides other styles */
  }

  .burger-button {
  font-size: 1.3rem; /* Adjust size as needed */
  cursor: pointer; /* Indicates clickable item */
  align-self: center;
}
}

</style>
